const moment = require('moment');

/**
 * Convert a Date object to an ISO8601 string to send to the API.
 *
 * The native date.toISOString() method also converts the timezone to zulu (UTC).
 * Using moment we can leave it in the local time (with the appropriate offset at the end). This makes it extra
 * clear what timezone we are dealing with and avoids confusion caused by sending UTC to the API.
 * e.g.
 * const d = new Date();        // Fri Apr 14 2023 16:38:03 GMT+0700 (Indochina Time)
 * d.toISOString();             // '2023-04-14T09:38:03.662Z'
 * moment(d).toISOString(true); // '2023-04-14T16:38:03.662+07:00'
 *
 * @param {Date} date
 *
 * @return {string}
 */
const formatDateForApi = (date) => {
    return moment(date).toISOString(true);
};

module.exports = {
    formatDateForApi,
};
